// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./BookingDetails.css";
// import CancelBookingDetailModal from "../CancellatonModals/CancelBookingDetailModal/CancelBookingDetailModal";
// import CancellationChargeModal from "../CancellatonModals/CancellationChargeModal/CancellationChargeModal";
// import SuccessfullyCancelledBookingModal from "../CancellatonModals/SuccessfullyCancelledBookingModal/SuccessfullyCancelledBookingModal";


// const BookingDetails = ({ onRaiseQuery, onRating }) => {
//   const navigate = useNavigate();
//   const [showCancelModal, setShowCancelModal] = useState(false);
//   const [showChargeModal, setShowChargeModal] = useState(false);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);

//   return (
//     <div className="booking-details-wrapper">

//       {/* Page Title */}
//       <h2 className="page-title">Wedding Photoshoot</h2>

//       <p className="section-heading">Booking Details</p>

//       {/* Booking Info Card */}
//       <div className="details-card">
//         <div className="row-between">
//           <p className="label">Booking For</p>
//           <p className="value">Riya Mehta</p>
//         </div>

//         <p className="sub-heading">Event Information</p>
//         <ul className="info-list">
//           <li>• Event Type: Wedding Photography</li>
//           <li>• Event Date: 24 March 2026</li>
//           <li>• Event Time: 10:00 AM – 10:00 PM</li>
//           <li>• Event Location: Mumbai, Maharashtra</li>
//         </ul>

//         <p className="sub-heading mt-3">Photography Package</p>
//         <p className="package-name">
//           Selected Package: Premium Wedding Coverage
//         </p>

//         <ul className="info-list">
//           <li>• Full-day coverage</li>
//           <li>• Candid + Traditional photography</li>
//           <li>• Lead Photographer + Assistant</li>
//           <li>• High-resolution edited images</li>
//         </ul>
//       </div>

//       {/* Billing Details */}
//       <p className="section-heading">Billing Details</p>

//       <div className="details-card">
//         <div className="row-between">
//           <p className="label">Package Price</p>
//           <p className="value">₹45,000</p>
//         </div>

//         <div className="row-between">
//           <p className="label">Taxes & Charges</p>
//           <p className="value">₹2,500</p>
//         </div>

//         <div className="row-between total">
//           <p className="label">Total Amount Paid</p>
//           <p className="value">₹47,500</p>
//         </div>

//         <div className="row-between mt-2">
//           <p className="label">Status Badge</p>
//           <p className="status completed">✔ Payment Completed</p>
//         </div>
//       </div>

//       {/* Actions */}
//       <div className="booking-actions">
//         <button className="action-btn" onClick={onRaiseQuery}>
//           Raise a Query
//         </button>

//         <button className="action-btn outline" onClick={onRating}>
//           Give Rating & Feedback
//         </button>

//         <p className="cancel-btn-main" onClick={() => setShowCancelModal(true)}>Cancel Booking</p>
//       </div>
      
//       {/* First Modal */}
//       <CancelBookingDetailModal
//           show={showCancelModal}
//           onClose={() => setShowCancelModal(false)}
//           onProceed={() => {
//           setShowCancelModal(false);
//           setShowChargeModal(true);
//         }}
//       />

//       {/* Second Modal */}
//       <CancellationChargeModal
//         show={showChargeModal}
//         onClose={() => setShowChargeModal(false)}
//         onConfirm={() => {
//           setShowChargeModal(false);
//           setShowSuccessModal(true);
//         }}
//       />
//        {/* 3️⃣ Success Modal */}
//       <SuccessfullyCancelledBookingModal
//         show={showSuccessModal}
//         onClose={() => setShowSuccessModal(false)}
//       />
//     </div>
    
//   );
// };

// export default BookingDetails;



import React, { useEffect, useState } from "react";
import "./BookingDetails.css";

import CancelBookingDetailModal from "../CancellatonModals/CancelBookingDetailModal/CancelBookingDetailModal";
import CancellationChargeModal from "../CancellatonModals/CancellationChargeModal/CancellationChargeModal";
import SuccessfullyCancelledBookingModal from "../CancellatonModals/SuccessfullyCancelledBookingModal/SuccessfullyCancelledBookingModal";

import {
  getOneUpcomingBookingById,
  putCancelBooking,
} from "../../../../../utils/APIs/bookingApis";
import {
  isCancelBookingDisabled,
  shouldShowCancelNoRefundWarning,
} from "../../../../../utils/cancelBookingUtils";
import Loader from "../../../../../Template/Loader/Loader";
import CommonMessageModal from "../../../../CommonMessageModal/CommonMessageModal";
import { LuPenSquare,  } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const BookingDetails = ({
  bookingId,
  setPhotographerId,
  setClientId,
  setServiceName,
  onRaiseQuery = () => {},
  onRating = () => {},
}) => {
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [photographerData,setPhotographerData] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showChargeModal, setShowChargeModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showAlreadyCancelledModal, setShowAlreadyCancelledModal] = useState(false);

  const [cancelReason, setCancelReason] = useState("");
  const [cancelNoRefundWarning, setCancelNoRefundWarning] = useState(false);
  const [editingTab, setEditingTab] = useState("sent"); // 'sent' or 'received'

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  /* =========================
     FETCH BOOKING BY ID
  ========================= */
  useEffect(() => {
    if (bookingId) {
      fetchBookingDetails();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [bookingId]);

  // const fetchBookingDetails = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await getOneUpcomingBookingById(bookingId);
  //     setBooking(response?.data?.data || null);
  //   } catch (error) {
  //     console.error("Booking details error:", error);
  //     setBooking(null);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const [expandedService, setExpandedService] = useState(null);

  const fetchBookingDetails = async () => {
    try {
      setLoading(true);
      const response = await getOneUpcomingBookingById(bookingId);
      const bookingData = response?.data?.data || null;
      setBooking(bookingData);

      if (bookingData?.photographer_id) {
        setPhotographerId(bookingData.photographer_id);
      }
      if (bookingData?.client_id?._id) {
        setClientId(bookingData.client_id._id);
      }
      if (bookingData?.service_id?.serviceName) {
        setServiceName(bookingData.service_id.serviceName);
      }
    } catch (error) {
      console.error("Booking details error:", error);
      setBooking(null);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     CANCEL BOOKING API
  ========================= */
  const handleCancelBooking = async () => {
    try {
      const payload = {
        status: "canceled",
        cancellationCharge: booking?.cancellationCharge || "0",
        cancellationDate: formatDate(new Date()),
        cancellationReason: cancelReason,
      };

      await putCancelBooking(bookingId, payload);

      setShowChargeModal(false);
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Cancel booking error:", error);
    }
  };

  /* =========================
     LOADER & FALLBACK
  ========================= */
  if (loading) return <Loader />;
  if (!booking) return <p>No booking details found</p>;

  const cancelDisabled = isCancelBookingDisabled(booking);

  const handleOpenCancelModal = async () => {
    if (cancelDisabled) return;

    if (booking.status === "canceled") {
      setShowAlreadyCancelledModal(true);
      return;
    }

    let latestBooking = booking;
    try {
      const response = await getOneUpcomingBookingById(bookingId);
      latestBooking = response?.data?.data || booking;
      if (latestBooking) {
        setBooking(latestBooking);
      }
    } catch (error) {
      console.error("Failed to refresh booking before cancel:", error);
    }

    setCancelNoRefundWarning(shouldShowCancelNoRefundWarning(latestBooking));
    setShowCancelModal(true);
  };

  const handleEditEventDetails = () => {
    const id = booking._id || bookingId;
    const returnUrl = `/bookingDetails/${id}?tab=details`;
    sessionStorage.setItem("bookingDetailsReturnUrl", returnUrl);
    sessionStorage.setItem("quoteReturnUrl", returnUrl);
    navigate(`/quote-event-address/${id}`);
  };

  return (
    <div className="booking-details-wrapper">
      {/* Page Title */}
      <h2 className="page-title">
        {booking.service_id?.serviceName || "Booking Details"}
      </h2>

      {/* Client Info Header */}
      <div className="details-card client-header-card">
        <div className="client-info">
          <div className="client-avatar">
            {booking.client_id?.username?.charAt(0).toUpperCase() || "U"}
          </div>
          <div className="client-text">
            <p className="label">Booking For</p>
            <p className="client-name">{booking.client_id?.username || "User"}</p>
          </div>
        </div>
      </div>

      <div className="section-heading-row">
        <p className="section-heading">Event Details</p>
        <button
          type="button"
          className="event-details-edit-btn"
          title="Edit event details"
          aria-label="Edit event details"
          onClick={handleEditEventDetails}
        >
          <LuPenSquare />
        </button>
      </div>
      <div className="details-card">
        <div className="row-between">
          <p className="label">Event Type</p>
          <p className="value">{booking.service_id?.serviceName || booking.eventType }</p>
        </div>
        <div className="row-between">
          <p className="label">Event Date</p>
          <p className="value">{new Date(booking.startDate || booking.eventDate || booking.date ).toLocaleDateString("en-IN", { day: '2-digit', month: 'long', year: 'numeric' })}</p>
        </div>
        <div className="row-between address-row">
          <p className="label">Event Address</p>
          <p className="value address-value">
            {booking.address || booking.location || `${booking.city || ''}, ${booking.state || ''}`.replace(/^,\s*|,\s*$/g, '')}
          </p>
        </div>
      </div>

      <p className="section-heading">Booked Services</p>
      <div className="details-card">
        {booking.bookedServices ? (
          <div className="service-cards-container">
            {booking.bookedServices.map((service, sIdx) => (
              <div key={sIdx} className="service-group">
                <div 
                  className={`service-type-card ${expandedService === service.type ? 'active' : ''}`}
                  onClick={() => setExpandedService(expandedService === service.type ? null : service.type)}
                >
                  <div className="service-info-main">
                    <span className="service-type-name">{service.type}</span>
                    <span className="service-count-badge">{service.count} {service.count > 1 ? 'Units' : 'Unit'} Booked</span>
                  </div>
                  <div className="expand-icon">
                    {expandedService === service.type ? '▲' : '▼'}
                  </div>
                </div>

                {expandedService === service.type && (
                  <div className="units-container">
                    {service.items.map((item) => (
                      <div key={item.id} className="unit-card">
                        <span className="unit-name">{item.name}</span>
                        <span className="unit-details">{item.details}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <>
            <p className="sub-heading mt-0">Photography Package</p>
            <p className="package-name">
              Selected Package: {booking.service_id?.serviceName}
            </p>
            
            {/* Conditional Package Details */}
            {booking.service_id?.serviceName?.toLowerCase().includes('hourly') ? (
              <ul className="info-list">
                <li><strong>• Duration:</strong> {booking.plan_id?.hours || 'N/A'} Hours</li>
                <li>• Standard equipment provided by photographer</li>
                <li>• High-resolution edited images via Gallery</li>
              </ul>
            ) : booking.service_id?.serviceName?.toLowerCase().includes('editing') ? (
              <ul className="info-list">
                <li><strong>• Plan:</strong> {booking.plan_id?.numberOfVideos || 'N/A'} Videos</li>
                <li>• Professional color grading and cutting</li>
                <li>• High-quality final render deliverables</li>
              </ul>
            ) : (
              <ul className="info-list">
                <li>• Full-day coverage</li>        
                <li>• Candid + Traditional photography</li>
                <li>• Lead Photographer + Assistant</li>
                <li>• High-resolution edited images</li>
              </ul>
            )}
          </>
        )}
      </div>

      {/* User Submissions for Editing Services with Sent/Received Tabs */}
      {booking.service_id?.serviceName?.toLowerCase().includes('editing') && (
        <>
          <div className="editing-flow-tabs">
            <button 
              className={`editing-tab ${editingTab === 'sent' ? 'active' : ''}`}
              onClick={() => setEditingTab('sent')}
            >
              Sent (Submissions)
            </button>
            <button 
              className={`editing-tab ${editingTab === 'received' ? 'active' : ''}`}
              onClick={() => setEditingTab('received')}
            >
              Received (Deliverables)
            </button>
          </div>

          {editingTab === 'sent' ? (
            <>
              <p className="section-heading">Your Submissions</p>
              <div className="details-card">
                {booking.userMedia && booking.userMedia.length > 0 ? (
                  <ul className="info-list">
                    {booking.userMedia.map((media, idx) => (
                      <li key={idx}>
                        <div className="row-between">
                          <span className="label">• {media.fileName || `File ${idx + 1}`}</span>
                          <span className={`status-badge ${media.status || 'pending'}`}>
                            {media.status || 'Uploaded'}
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <>
                    <p className="package-name">No files uploaded yet.</p>
                    <p className="package-name">Deliverables coming soon</p>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <p className="section-heading">Photographer Deliverables</p>
              <div className="details-card">
                <p className="package-name">Final edited files will be available in the Gallery tab once completed.</p>
              </div>
            </>
          )}
        </>
      )}

      {/* Billing Details */}
      <p className="section-heading">Billing Details</p>

      <div className="details-card">
        <div className="row-between total mb-0">
          <p className="package-name">Package Price</p>
          <p className="package-name">₹ 00</p>
          </div>
         
          <div className="row-between total mb-0">
          <p className="package-name">Taxes & Charges</p>
          <p className="package-name">₹ 00</p>
          </div>

        <div className="row-between total">
          <p className="label">Total Amount</p>
          <p className="value">₹ {booking.finalAmount || booking.totalAmount}</p>
        </div>

        <div className="row-between mt-2">
          <p className="label">Status Badge</p>
          <p className={`paymentStatus ${booking.paymentStatus}`}>
            {booking.paymentStatus.charAt(0).toUpperCase() +
              booking.paymentStatus.slice(1)}
          </p>
        </div>
      </div>

      {/* Actions */}
      <div className="booking-actions-details">
        <button
          type="button"
          className="action-btn"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onRaiseQuery({
            bookingId: booking._id,
            serviceId: booking.service_id?._id,
            clientId: booking.client_id?._id,
            serviceName: booking.service_id?.serviceName,
          });
          }}
        >
          Raise a Query
        </button>

        {
       booking?.status?.toLowerCase() === "gallery delivery" &&
       (<button
          type="button"
          className="action-btn outline"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
             onRating({
              bookingId: booking._id,
              serviceId: booking.service_id?._id,
              serviceName: booking.service_id?.serviceName,
              clientId: booking.client_id?._id,
            });
          }}
        >
          Give Rating & Feedback
        </button>
      )}

        {/* <p
          className="cancel-btn-main"
          onClick={() => {
            if (booking.status === "canceled") {
              setShowAlreadyCancelledModal(true);
            } else {
              setShowCancelModal(true);
            }
          }}
        >
          Cancel Booking
        </p> */}

        <button
          type="button"
          className={`action-btn outline ${cancelDisabled ? "disabled-cancel" : ""}`}
          disabled={cancelDisabled}
          title={
            cancelDisabled
              ? booking.isGalleryPublished
                ? "Gallery has been published so it cannot be cancelled"
                : "This booking cannot be cancelled"
              : ""
          }
          onClick={handleOpenCancelModal}
        >
          Cancel Booking
        </button>

      </div>

      {/* Modals */}
      <CancelBookingDetailModal
        show={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        mediaUploadedWarning={cancelNoRefundWarning}
        onProceed={(reason) => {
          setCancelReason(reason);
          setShowCancelModal(false);
          setShowChargeModal(true);
        }}
      />

      <CancellationChargeModal
        show={showChargeModal}
        onClose={() => setShowChargeModal(false)}
        onConfirm={handleCancelBooking}
        charge={booking?.cancellationCharge || "0"}
      />

      <SuccessfullyCancelledBookingModal
        show={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
      />

      <CommonMessageModal
        show={showAlreadyCancelledModal}
        onClose={() => setShowAlreadyCancelledModal(false)}
        message="This booking is already cancelled."
        buttonText="Okay"
      />
    </div>
  );
};

export default BookingDetails;
